import angular from 'angular';
import { default as addSupportTicketDialog } from 'app/components/global/addSupportTicketDialog';
import controller from './contact-us-dialog.controller';
import template from './contact-us-dialog.html';

const library = require('@safe-systems/ss-ui-components');

const {
  ssDialogService,
} = library;

class dialogService {
  getOptions() {
    return {
      controller,
      controllerAs: 'contactUsDialogVM',
      locals: {},
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      template,
    };
  }
}

export default angular.module('app.components.global.userBar.contactUsDialog', [
  addSupportTicketDialog,
  ssDialogService,
])
  .service('contactUsDialog', dialogService)
  .name;
